import { useEffect, useRef } from "react";
import { edges, nodeCount, signalCount } from "./orb-data";
import { preloadChatActionMotion } from "./preload";

export function ThinkingGeometry({ animated }: { animated: boolean }) {
  const root = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    if (!animated) return;
    let disposed = false;
    let stop: (() => void) | undefined;
    void preloadChatActionMotion().then((motion) => {
      if (!disposed && root.current)
        stop = motion?.startOrbMotion(root.current);
    });
    return () => {
      disposed = true;
      stop?.();
    };
  }, [animated]);

  return (
    <span
      ref={root}
      className="web-orb"
      data-animated={animated ? "true" : undefined}
    >
      {edges.map(([a, b]) => (
        <i key={`${a}-${b}`} className={`edge chat-orb-edge-${a}-${b}`} />
      ))}
      {Array.from({ length: nodeCount }, (_, i) => (
        <i key={i} className={`node chat-orb-node-${i}`} />
      ))}
      {Array.from({ length: signalCount }, (_, i) => (
        <i key={i} className={`packet chat-orb-packet-${i}`} />
      ))}
    </span>
  );
}
